<template>
  <v-dialog
    v-model="confirmationDialog"
    persistent
    width="fit-content"
  >
    <v-card>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="noColor"
          @click="() => noConfirmationDialog()"
        >
          {{ noTitle }}
        </v-btn>
        <v-btn
          :color="yesColor"
          @click="() => yesConfirmationDialog()"
        >
          {{ yesTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "confirmation",
  props: {
    confirmationDialogStatus: Boolean,
    message : String,
    yesTitle : String,
    yesColor : String,
    noTitle : String,
    noColor : String,
    data : Object,
  },
  data () {
    return {
      confirmationDialog: this.confirmationDialogStatus // Initial value
    }
  },
  watch: {
    confirmationDialogStatus (newValue) {
      this.confirmationDialog = newValue // Update when the prop changes
    }
  },
  methods: {
    noConfirmationDialog() {
      this.confirmationDialog = false
      this.$emit("no");
    },
    yesConfirmationDialog() {
      this.$emit("yes",this.data) ;
      this.confirmationDialog = false
    },
  }
}
</script>

<style scoped>

</style>
